/**
 * API Service - Centralized HTTP client for backend communication
 * Handles authentication, error handling, and all API calls
 */

import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add JWT token to every request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle response errors globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth endpoints
export const authAPI = {
  register: (email, password) =>
    api.post('/auth/register', { email, password }),
  login: (email, password) =>
    api.post('/auth/login', { email, password }),
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },
};

// Newsletter endpoints
export const newsletterAPI = {
  upload: (formData) =>
    api.post('/newsletter/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  getAll: () => api.get('/newsletter'),
  getById: (id) => api.get(`/newsletter/${id}`),
  delete: (id) => api.delete(`/newsletter/${id}`),
};

// Validation endpoints
export const validationAPI = {
  checkUrl: (url) =>
    api.post('/validation/check', { url }),
  getResults: (newsletterId) =>
    api.get(`/validation/results/${newsletterId}`),
};

export default api;
